import React from "react";
import { useSelector } from "react-redux";
import SummaryWrapper from "./SummaryWrapper.style";
import AttributesList from "../../../components/layouts/AttributesList";

const Summary = (props) => {
  const summary = useSelector((state) => state.prospectuses.summary);

  const attributes = {};
  const { charged_amount, charged_units, paid_amount, refund_amount } =
    summary || {};

  if (charged_units !== undefined) {
    attributes["app.prospectuses.charged_minutes"] = charged_units;
  }

  if (charged_amount !== undefined) {
    attributes["app.prospectuses.charged_amount"] = new Intl.NumberFormat(
      "he",
      {
        style: "currency",
        currency: "ILS",
        maximumFractionDigits: 2,
      }
    ).format(charged_amount);
  }

  if (paid_amount !== undefined) {
    attributes["app.prospectuses.paid_amount"] = new Intl.NumberFormat("he", {
      style: "currency",
      currency: "ILS",
      maximumFractionDigits: 2,
    }).format(paid_amount);
  }
  if (refund_amount !== undefined) {
    attributes["app.prospectuses.refund_amount"] = new Intl.NumberFormat("he", {
      style: "currency",
      currency: "ILS",
      maximumFractionDigits: 2,
    }).format(refund_amount);
  }
  return (
    <SummaryWrapper>
      <AttributesList attributes={attributes} />
    </SummaryWrapper>
  );
};

export default Summary;
